<template>
    <v-dialog v-model="dialog" max-width="500px" id="message-update__modal">
        <template v-slot:activator="{ on }">
            <v-btn
                color="warning"
                dark
                class="mb-2 edit-invoice-button"
                v-on="on"
                v-on:click="editItem()"
            >
                Edit
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">Edit Message</span>
            </v-card-title>

            <v-card-text>
                <v-container grid-list-md>
                    <v-row wrap>
                        <v-col cols="4" xs12 sm6 md4>
                            <v-text-field
                                v-model="editedItem.subject"
                                label="Subject"
                                id="message-update__displayedSubject"
                            />
                        </v-col>
                        <v-col cols="8" xs12 sm6 md4>
                            <v-text-field
                                v-model="editedItem.message"
                                label="Message"
                                id="message-update__displayedMessage"
                            />
                        </v-col>
                        <v-col cols="6" xs12 sm6 md4>
                            <v-select
                                v-model="editedItem.messageType"
                                :items="messageTypes"
                                item-text="messageType"
                                item-value="uid"
                                label="Message Type"
                                return-object
                            />
                        </v-col>
                        <v-col cols="6" xs12 sm6 md4>
                            <v-select
                                v-model="editedItem.messageGroup"
                                :items="messageGroups"
                                item-text="messageGroup"
                                item-value="uid"
                                label="Recipients"
                                return-object
                                readonly
                            />
                        </v-col>
                        <v-col cols="6" xs12 sm6 md4>
                            <v-text-field
                                v-model="editedItem.user"
                                label="Sender"
                                id="message-update__displayedSender"
                                readonly
                            />
                        </v-col>
                        <v-col cols="6" xs12 sm6 md4>
                            <v-text-field
                                v-model="editedItem.createdAt"
                                label="Date"
                                readonly
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'MessageUpdate',
    props: {
        message: {
            type: Object,
            required: true,
            default: () => ({
                uid: '',
                user: '',
                subject: '',
                message: '',
                messageType: {
                    uid: '',
                    messageType: ''
                },
                messageGroup: {
                    uid: '',
                    messageGroup: ''
                },
                createdAt: ''
            })
        },
        messageTypes: {
            type: Array,
            required: true,
            default: () => ({})
        },
        messageGroups: {
            type: Array,
            required: true,
            default: () => ({})
        }
    },
    data() {
        return {
            dialog: false,
            editedItem: {
                user: '',
                subject: '',
                message: '',
                messageType: { uid: '', messageType: '' },
                messageGroup: { uid: '', messageGroup: '' }
            },
            defaultItem: {
                user: '',
                subject: '',
                message: '',
                messageType: { uid: '', messageType: '' },
                messageGroup: { uid: '', messageGroup: '' }
            }
        };
    },
    methods: {
        editItem() {
            this.editedItem = Object.assign({}, this.message);
        },

        close() {
            this.dialog = false;
            this.editedItem = Object.assign({}, this.defaultItem);
        },

        save() {
            this.$store.dispatch('messageUpdate', {
                formData: this.editedItem
            });
            this.close();
        }
    }
};
</script>
